<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_26_938)">
<rect x="2" y="26" width="24" height="24" rx="12" transform="rotate(-90 2 26)" fill="#e8cbf2"/>
<rect x="2" y="26" width="24" height="24" rx="12" transform="rotate(-90 2 26)" fill="#8148a8"/>
<circle cx="14" cy="14" r="4" transform="rotate(-90 14 14)" fill="white"/>
</g>
<rect x="1" y="27" width="26" height="26" rx="13" transform="rotate(-90 1 27)" stroke="#e8cbf2" stroke-width="2"/>
<defs>
<clipPath id="clip0_26_938">
<rect x="2" y="26" width="24" height="24" rx="12" transform="rotate(-90 2 26)" fill="white"/>
</clipPath>
</defs>
</svg>
